import { Td } from '@met/react-components';
import styled from 'styled-components';

export const KeyColumn = styled(Td)`
  @media (min-width: ${props => props.theme.screenSize.md}) {
    max-width: 120px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;

export const ReferenceValueColumn = styled(Td)`
  @media (min-width: ${props => props.theme.screenSize.md}) {
    max-width: 200px;
  }
`;
